var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayCircleOutlinecomponent = function SvgPlayCircleOutlinecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3.167C10.26 3.167 3.167 10.26 3.167 19S10.26 34.833 19 34.833 34.834 27.74 34.834 19 27.74 3.167 19 3.167Zm-3.166 22.958 9.5-7.125-9.5-7.125v14.25ZM6.334 19c0 6.983 5.684 12.667 12.666 12.667 6.983 0 12.667-5.684 12.667-12.667 0-6.982-5.684-12.667-12.667-12.667-6.982 0-12.666 5.684-12.666 12.667Z",
    fill: "#fff"
  })));
};
export default SvgPlayCircleOutlinecomponent;